import {
  GAS_ESTIMATION_BUFFER,
  ZERO_ADDRESS,
} from '@/Overtime/constants/network'
import type { SupportedNetwork } from '@/Overtime/types/network'
import type { ViemContract } from '@/Overtime/types/viem'
import { type Address, type Client, encodeFunctionData } from 'viem'
import { estimateGas } from 'viem/actions'
import { optimismSepolia } from 'viem/chains'
import type { TradeData } from '../types/markets'
import {
  isGasSponsorshipSupported,
  isFeatureSupported,
} from 'local_modules/wallet/config/gasSponsorship'
// import { useWriteContract } from 'wagmi'
// import { executeBiconomyTransaction } from './smartAccount/biconomy/biconomy';

export const getSportsAMMV2Transaction: any = async (
  collateralAddress: string,
  isDefaultCollateral: boolean,
  isEth: boolean,
  networkId: SupportedNetwork,
  sportsAMMV2Contract: ViemContract,
  freeBetHolderContract: ViemContract,
  tradeData: TradeData[],
  buyInAmount: bigint,
  expectedQuote: bigint,
  referral: string | null,
  additionalSlippage: bigint,
  isAA: boolean,
  isFreeBet: boolean,
  client: Client,
  isSystemBet: boolean,
  systemBetDenominator: number,
  executeGaslessTransaction?: (
    to: `0x${string}`,
    data: `0x${string}`,
    value?: bigint
  ) => Promise<`0x${string}`>
): Promise<any> => {
  let finalEstimation: bigint | null
  const referralAddress = referral || ZERO_ADDRESS
  const hasGasSponsorship =
    isGasSponsorshipSupported(networkId) &&
    isFeatureSupported(networkId, 'sponsorBets')

  if (!tradeData || !Array.isArray(tradeData)) {
    throw new Error('Invalid tradeData: must be a non-empty array')
  }

  // if (isFreeBet && freeBetHolderContract) {
  //     if (isSystemBet) {
  //         const encodedData = encodeFunctionData({
  //             abi: freeBetHolderContract.abi,
  //             functionName: 'tradeSystemBet',
  //             args: [
  //                 tradeData,
  //                 buyInAmount,
  //                 expectedQuote,
  //                 additionalSlippage,
  //                 referralAddress,
  //                 collateralAddress,
  //                 systemBetDenominator,
  //             ],
  //         });

  //         if (!isAA) {
  //             const estimation = await estimateGas(client, {
  //                 to: freeBetHolderContract.address as Address,
  //                 data: encodedData,
  //             });

  //             finalEstimation = BigInt(Math.ceil(Number(estimation) * GAS_ESTIMATION_BUFFER));

  //             return freeBetHolderContract.write.tradeSystemBet(
  //                 [
  //                     tradeData,
  //                     buyInAmount,
  //                     expectedQuote,
  //                     additionalSlippage,
  //                     referralAddress,
  //                     collateralAddress,
  //                     systemBetDenominator,
  //                 ],
  //                 { value: BigInt(0), gas: finalEstimation }
  //             );
  //         } else
  //             return await executeBiconomyTransaction({
  //                 networkId,
  //                 contract: freeBetHolderContract,
  //                 methodName: 'tradeSystemBet',
  //                 collateralAddress: collateralAddress as any,
  //                 data: [
  //                     tradeData,
  //                     buyInAmount,
  //                     expectedQuote,
  //                     additionalSlippage,
  //                     referralAddress,
  //                     collateralAddress,
  //                     systemBetDenominator,
  //                 ],
  //             });
  //     } else {
  //         const encodedData = encodeFunctionData({
  //             abi: freeBetHolderContract.abi,
  //             functionName: 'trade',
  //             args: [tradeData, buyInAmount, expectedQuote, additionalSlippage, referralAddress, collateralAddress],
  //         });

  //         if (!isAA) {
  //             const estimation = await estimateGas(client, {
  //                 to: freeBetHolderContract.address as Address,
  //                 data: encodedData,
  //             });

  //             finalEstimation = BigInt(Math.ceil(Number(estimation) * GAS_ESTIMATION_BUFFER));

  //             return freeBetHolderContract.write.trade(
  //                 [tradeData, buyInAmount, expectedQuote, additionalSlippage, referralAddress, collateralAddress],
  //                 { value: BigInt(0), gas: finalEstimation }
  //             );
  //         } else {
  //             return await executeBiconomyTransaction({
  //                 collateralAddress: collateralAddress as Address,
  //                 networkId,
  //                 contract: freeBetHolderContract,
  //                 methodName: 'trade',
  //                 data: [
  //                     tradeData,
  //                     buyInAmount,
  //                     expectedQuote,
  //                     additionalSlippage,
  //                     referralAddress,
  //                     collateralAddress,
  //                 ],
  //             });
  //         }
  //     }
  // }

  // if (isSystemBet) {
  //     const encodedData = encodeFunctionData({
  //         abi: sportsAMMV2Contract.abi,
  //         functionName: 'tradeSystemBet',
  //         args: [
  //             tradeData,
  //             buyInAmount,
  //             expectedQuote,
  //             additionalSlippage,
  //             referralAddress,
  //             collateralAddress,
  //             isEth,
  //             systemBetDenominator,
  //         ],
  //     });

  //     if (!isAA) {
  //         const estimation = await estimateGas(client, {
  //             to: sportsAMMV2Contract.address as Address,
  //             data: encodedData,
  //             value: isEth ? buyInAmount : BigInt(0),
  //         });

  //         finalEstimation = BigInt(Math.ceil(Number(estimation) * GAS_ESTIMATION_BUFFER));

  //         return sportsAMMV2Contract.write.tradeSystemBet(
  //             [
  //                 tradeData,
  //                 buyInAmount,
  //                 expectedQuote,
  //                 additionalSlippage,
  //                 referralAddress,
  //                 isDefaultCollateral ? ZERO_ADDRESS : collateralAddress,
  //                 isEth,
  //                 systemBetDenominator,
  //             ],
  //             { value: isEth ? buyInAmount : BigInt(0), gas: finalEstimation }
  //         );
  //     } else {
  //         return await executeBiconomyTransaction({
  //             networkId,
  //             collateralAddress: collateralAddress as any,
  //             contract: sportsAMMV2Contract,
  //             methodName: 'tradeSystemBet',
  //             data: [
  //                 tradeData,
  //                 buyInAmount,
  //                 expectedQuote,
  //                 additionalSlippage,
  //                 referralAddress,
  //                 isDefaultCollateral ? ZERO_ADDRESS : collateralAddress,
  //                 isEth,
  //                 systemBetDenominator,
  //             ],
  //             value: isEth ? buyInAmount : BigInt(0),
  //         });
  //     }
  // } else {
  const encodedData = encodeFunctionData({
    abi: sportsAMMV2Contract.abi,
    functionName: 'trade',
    args: [
      tradeData,
      buyInAmount,
      expectedQuote,
      additionalSlippage,
      referralAddress,
      isDefaultCollateral ? ZERO_ADDRESS : collateralAddress,
      isEth,
    ],
  })

  // If gas sponsorship is available and supported for bets, use it
  if (hasGasSponsorship && executeGaslessTransaction) {
    try {
      return await executeGaslessTransaction(
        sportsAMMV2Contract.address as Address,
        encodedData,
        isEth ? buyInAmount : BigInt(0)
      )
    } catch (error) {
      console.error(
        'Gasless transaction failed, falling back to regular transaction:',
        error
      )
      // Fall through to regular transaction
    }
  }

  // Regular transaction logic
  if (!isAA) {
    const estimation = await estimateGas(client, {
      to: sportsAMMV2Contract.address as Address,
      data: encodedData,
      value: isEth ? buyInAmount : BigInt(0),
    })

    finalEstimation = BigInt(
      Math.ceil(Number(estimation) * GAS_ESTIMATION_BUFFER)
    )

    return sportsAMMV2Contract.write.trade(
      [
        tradeData,
        buyInAmount,
        expectedQuote,
        additionalSlippage,
        referralAddress,
        isDefaultCollateral ? ZERO_ADDRESS : collateralAddress,
        isEth,
      ],
      { value: isEth ? buyInAmount : BigInt(0), gas: finalEstimation }
    )
  }

  // If AA wallet but not OP Sepolia, use existing AA logic
  throw new Error('AA wallet transaction not implemented for this network')
}

export const getSportsAMMV2QuoteMethod: any = (
  collateralAddress: string,
  isDefaultCollateral: boolean,
  sportsAMMV2Contract: ViemContract,
  tradeData: TradeData[],
  buyInAmount: bigint,
  isSystemBet: boolean,
  systemBetDenominator: number
) => {
  return isSystemBet
    ? sportsAMMV2Contract.read.tradeQuoteSystem([
        tradeData,
        buyInAmount,
        isDefaultCollateral ? ZERO_ADDRESS : collateralAddress,
        false,
        systemBetDenominator,
      ])
    : sportsAMMV2Contract.read.tradeQuote([
        tradeData,
        buyInAmount,
        isDefaultCollateral ? ZERO_ADDRESS : collateralAddress,
        false,
      ])
}
